














































































































































































import { Component, Mixins, Prop, Vue } from 'vue-property-decorator'
import UnitDetailMixin from '@/components/mixins/UnitDetailListMixin.vue'
import UserModel from '@/_models/UserModel'

@Component({})
export default class UserList extends Mixins(UnitDetailMixin) {
  public pageFilters: any = {
    currentPage: 1,
    perPage: 10,
    selectedFilter: 'name',
    searchQuery: '',
    activeTab: 0, // 0: people, 1: things
  }

  public filedNameLUT: any = {
    _id: 'UUID',
    user_id: 'label.user_id',
    name: 'label.username',
    category_name: 'label.category',
    category_id: 'label.category_id',
    san_id: 'label.card_number',
    major: 'label.major',
    minor: 'label.minor',
  }

  get users(): UserModel[] {
    const users = this.$store.state.units.all.users
    this.numofPage = Math.ceil(users.length / this.pageFilters.perPage)

    return users
  }

  get totalPeopleType() {
    return this.users.filter(user => user.user_type === 'people').length
  }

  get totalThingsType() {
    return this.users.filter(user => user.user_type === 'things').length
  }

  get filteredData(): UserModel[] {
    const targetField: string = this.pageFilters.selectedFilter
    if (!this.users) {
      return []
    }

    return this.users.filter((item: UserModel): boolean => {
      const searchKey =
        String(item[targetField])
          .toLowerCase()
          .indexOf(this.pageFilters.searchQuery.toString().toLowerCase()) !==
          -1 || item._id === this.pageFilters.searchQuery // Can search by uuid

      const validPeople =
        item.user_type === 'people' && this.pageFilters.activeTab === 0
      const validThing =
        item.user_type === 'things' && this.pageFilters.activeTab === 1

      return searchKey && (validPeople || validThing)
    })
  }

  public confirmMultiDelete() {
    const ids = this.checkedRows.map((item: UserModel) => item._id)
    const labels = this.checkedRows.map((item: UserModel) => `[${item.user_type}] - [${item.san_id || item.major + '/' + item.minor}] - ${item.name}`)
    this.handleConfirmMultipleDelete('user', ids, labels)
  }

  public confirmSingleDelete(selectedItem: UserModel) {
    const ids = [selectedItem._id]
    const labels = [`[${selectedItem.user_type}] - [${selectedItem.san_id || selectedItem.major + '/' + selectedItem.minor}] - ${selectedItem.name}`]
    this.handleConfirmMultipleDelete('user', ids, labels)
  }

  private created() {
    this.$store.dispatch('units/getAllUsers', this.selected)
  }
}
